import { render, staticRenderFns } from "./ProductOptionsModal.vue?vue&type=template&id=224bb6f0&scoped=true&"
import script from "./ProductOptionsModal.vue?vue&type=script&lang=js&"
export * from "./ProductOptionsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionsModal.vue?vue&type=style&index=0&id=224bb6f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224bb6f0",
  null
  
)

export default component.exports